import { Search, Menu, ArrowLeft } from "lucide-react";
import i1 from "../../assets/i2.png";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const DocsHeader = ({ searchText, onSearchChange, onSidebarOpen }) => {
  const navigate = useNavigate();

  return (
    <motion.header
      className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-gray-200"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between h-16 gap-4 sm:gap-0">
          {/* Left: Back, Hamburger, Logo, Title */}
          <div className="flex items-center flex-shrink-0 space-x-3">
            {/* Back */}
            <button
              onClick={() => navigate("/main")}
              aria-label="Go back"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#01CC54]/40"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
            {/* Hamburger (mobile) */}
            <button
              onClick={onSidebarOpen}
              aria-label="Open sidebar"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#01CC54]/40 sm:hidden"
            >
              <Menu className="w-6 h-6" />
            </button>
            {/* Logo + Text */}
            <img
              src={i1}
              alt="Ping By BluTec.ai"
              width={60}
              height={60}
              className="block sm:w-[80px] sm:h-auto"
            />
            {/* <div className="hidden sm:block leading-tight">
              <h1 className="text-xl font-bold text-gray-900 whitespace-nowrap">
                Ping By BluTec.ai
              </h1>
              <span className="text-sm text-gray-600">Documentation</span>
            </div> */}
          </div>

          {/* Right: Search */}
          <div className="flex-1 min-w-[200px] max-w-full sm:max-w-xs relative">
            <Search className="w-4 h-4 text-gray-500 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
            <input
              type="search"
              placeholder="Search docs..."
              value={searchText}
              onChange={onSearchChange}
              className="
                w-full pl-10 pr-4 py-2
                bg-gray-50 border border-gray-200 rounded-lg
                text-sm text-gray-900 placeholder-gray-500
                focus:outline-none focus:ring-2 focus:ring-[#01CC54]/20 focus:border-[#01CC54]
                transition
              "
              aria-label="Search documentation"
            />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default DocsHeader;
